import { SequenceCompletion } from '@/webgl/runner/scenarios/SequenceCompletion'

import RunnerGoalSyllableItemCollected from './RunnerGoalSyllableItemCollected'

export type RunnerGoalSyllableProps = {
  completion: SequenceCompletion
}

export default function RunnerGoalSyllable({ completion }: RunnerGoalSyllableProps) {
  const currentBlock = completion.blocks[completion.currentBlock]

  return (
    <div className='RunnerGoalVariant Runner__goal-syllable relative px-12 md:px-24 flex items-center bg-tertiary border-4 border-mid-blue min-h-88 min-w-88 p-8 rounded-24 mt-16 text-body-l'>
      {currentBlock.goal.map((goal, index) => (
        <span key={index}>
          {currentBlock.collected.includes(goal) ? <RunnerGoalSyllableItemCollected goal={goal} /> : <>{goal}</>}
        </span>
      ))}
    </div>
  )
}
